<style scoped>
    .btnHover {
        color: red !important
    }

    .vs-table--tbody-table .tr-values td {
        padding: 10px;
    }

    .vehicle-select-container {
        position: relative;
        width: 100%;
    }

    .vehicle-select-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        cursor: pointer;
    }
</style>

<template v-if="data">
    <div>
        <div class="w-full vx-col mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Delivery Order</h4>
                    </div>
                    <div class="flex items-center">
                        <!-- <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="createDo">Create Delivery Order</vs-button> -->
                        <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="editMode = true" v-if="!editMode" icon="edit">Edit</vs-button>
                        <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="submitForm" v-if="editMode" icon="save">Save</vs-button>
                        <vs-dropdown vs-trigger-click v-if="!editMode">
                            <vs-button class="mb-4 mr-1 btn md:mb-0" icon="apps">Process</vs-button>
                            <vs-dropdown-menu>
                                <vs-dropdown-group vs-collapse vs-label="Movement Order">
                                    <vs-dropdown-group vs-collapse vs-label="Picking">
                                        <vs-dropdown-item @click="pickBackground"> Pick Background </vs-dropdown-item>
                                        <vs-dropdown-item @click="pickForeground"> Pick Foreground </vs-dropdown-item>
                                        <vs-dropdown-item @click="printPickListInit" divider> Picking List </vs-dropdown-item>
                                    </vs-dropdown-group>
                                    <vs-dropdown-group vs-collapse vs-label="Reverse Picking">
                                        <vs-dropdown-item @click="reversePick"> Background Reverse </vs-dropdown-item>
                                        <vs-dropdown-item @click="reverseForeground"> Foreground Reverse </vs-dropdown-item>
                                        <vs-dropdown-item @click="printReversePickListInit" divider> Reverse Pick-List </vs-dropdown-item>
                                    </vs-dropdown-group>
                                    <vs-dropdown-item divider> View Movement </vs-dropdown-item>
                                    <vs-dropdown-item @click="confirmMo"> Confirm Movement </vs-dropdown-item>
                                </vs-dropdown-group>
                                <vs-dropdown-group vs-collapse vs-label="Checking and Packing">
                                    <vs-dropdown-item @click="checkingAndPacking"> Checking and Packing </vs-dropdown-item>
                                    <vs-dropdown-item @click="printPackingList"> Print Packing List </vs-dropdown-item>
                                    <vs-dropdown-item @click="showPrintLabelPrompt = true"> Print Packing Label </vs-dropdown-item>
                                </vs-dropdown-group>
                                <vs-dropdown-item @click="activeGoodIssue = true" icon="remove_red_eye" divider> Good Issue </vs-dropdown-item>
                                <!-- <vs-dropdown-item @click="cancelGoodIssue"> Cancel Good Issue </vs-dropdown-item> -->
                            </vs-dropdown-menu>
                        </vs-dropdown>
                        <vs-dropdown vs-trigger-click v-if="!editMode">
                            <vs-button class="mb-4 btn md:mb-0" icon="print">Print</vs-button>
                            <vs-dropdown-menu>
                                <vs-dropdown-item @click="printDoNote"> DO Note </vs-dropdown-item>
                                <vs-dropdown-item @click="printTallySheet"> Tally Sheet </vs-dropdown-item>
                                <vs-dropdown-item @click="printInvoice"> Invoice </vs-dropdown-item>
                                <vs-dropdown-item @click="printBast"> BAST </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                DO ID*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.id" disabled/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Outbound Reference*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.outbound_reference" disabled/>
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                DO Reference*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.do_reference" :disabled="!editMode"/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Request Delivery Date*
                            </div>
                            <div class="w-2/3 vx-col">
                                <flat-pickr class="w-full" v-model="data.req_del_date" disabled/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Client*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.client_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Origin*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.origin_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Address
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.origin_address_1" :disabled="true"/>
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                &nbsp;
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.origin_address_2" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Destination*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.destination_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Address
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.destination_address_1" :disabled="true"/>
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                &nbsp;
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full" v-model="data.destination_address_2" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                DO Status
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-input class="w-full mb-1" v-model="data.status" disabled/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Order Type*
                            </div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.order_type_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="mt-1 mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Posting Date
                            </div>
                            <div class="w-2/3 vx-col">
                                <flat-pickr class="w-full" v-model="data.posting_date" :disabled="!editMode"/>
                            </div>
                        </div>
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">
                                Order Date
                            </div>
                            <div class="w-2/3 vx-col">
                                <flat-pickr class="w-full" v-model="data.po_date" disabled/>
                            </div>
                        </div>
                            <div class="mb-3 vx-row">
                        <div class="w-1/3 vx-col">
                            Attachment
                        </div>
                        <div class="w-2/3 vx-col">
                    <input
                type="file"
                id="file_name"
                v-on:change="handleFileUpload($event)" :disabled="!editMode"
                />
                </div>
            </div>
                    </div>
                </div>
                <vs-tabs class="mt-10">
                    <vs-tab label="Item Details">
                        <vs-table :data="data.details" hoverFlat class="mt-5" pagination max-items="20" search>
                            <template slot="thead">
                                <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                                <vs-th style="min-width: 120px;">Warehouse ID</vs-th>
                                <vs-th style="min-width: 120px;">Product ID</vs-th>
                                <vs-th style="min-width: 120px;">Description</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">UoM</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Stock Type</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Picked Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Open Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Base UoM</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="detail" :key="index" v-for="(detail, index) in data" v-show="detail.status != 'delete'">
                                    <vs-td> {{ detail.line_id }} </vs-td>
                                    <vs-td> {{ detail.warehouse_code }} </vs-td>
                                    <vs-td> {{ detail.product_code }} </vs-td>
                                    <vs-td> {{ detail.description_1 }} </vs-td>
                                    <vs-td> {{ detail.pack_id }} </vs-td>
                                    <vs-td> {{ detail.batch }} </vs-td>
                                    <vs-td> {{ detail.expired_date }} </vs-td>
                                    <vs-td> {{ detail.qty }} </vs-td>
                                    <vs-td> {{ detail.uom }} </vs-td>
                                    <vs-td> {{ detail.stock_type }} </vs-td>
                                    <vs-td> {{ detail.picked_qty }} </vs-td>
                                    <vs-td> {{ detail.open_qty }} </vs-td>
                                    <vs-td> {{ detail.base_qty }} </vs-td>
                                    <vs-td> {{ detail.base_uom }} </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                    <vs-tab label="Picking">
                        <vs-table :data="data.picking" hoverFlat class="mt-5" stripe max-items="10" pagination search>
                            <template slot="thead">
                                <vs-th style="min-width: 70px; width: 70px">Movement ID</vs-th>
                                <vs-th style="min-width: 120px;">DO Line ID</vs-th>
                                <vs-th style="min-width: 120px;">Warehouse ID</vs-th>
                                <vs-th style="min-width: 120px;">Product ID</vs-th>
                                <vs-th style="min-width: 120px;">Description</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Base UoM</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Stock Type</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Src. Location Type</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Src. Location</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Src. Storage Unit</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Dest. Location Type</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Dest. Location</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Dest. Storage Unit</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Status</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="detail" :key="index" v-for="(detail, index) in data">
                                    <vs-td> {{ detail.movement_id }} </vs-td>
                                    <vs-td> {{ detail.do_line_id }} </vs-td>
                                    <vs-td> {{ detail.warehouse_code }} </vs-td>
                                    <vs-td> {{ detail.product_code }} </vs-td>
                                    <vs-td> {{ detail.description_1 }} </vs-td>
                                    <vs-td> {{ detail.pack_id }} </vs-td>
                                    <vs-td> {{ detail.batch }} </vs-td>
                                    <vs-td> {{ detail.expired_date }} </vs-td>
                                    <vs-td> {{ detail.base_qty }} </vs-td>
                                    <vs-td> {{ detail.base_uom }} </vs-td>
                                    <vs-td> {{ detail.stock_type }} </vs-td>
                                    <vs-td> {{ detail.source_location_type }} </vs-td>
                                    <vs-td> {{ detail.source_location }} </vs-td>
                                    <vs-td> {{ detail.source_storage_unit }} </vs-td>
                                    <vs-td> {{ detail.destination_location_type }} </vs-td>
                                    <vs-td> {{ detail.destination_location }} </vs-td>
                                    <vs-td> {{ detail.destination_storage_unit }} </vs-td>
                                    <vs-td> {{ detail.status }} </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                    <vs-tab label="Checking">
                        <vs-table :data="data.packing" hoverFlat class="mt-5" stripe max-items="10" pagination search>
                            <template slot="thead">
                                <vs-th style="min-width: 120px; width: 120px">Carton ID</vs-th>
                                <vs-th style="min-width: 120px;">Product ID</vs-th>
                                <vs-th style="min-width: 120px;">Description</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Check Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Check UoM</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Base UoM</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Stock Type</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Update Time</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="detail" :key="index" v-for="(detail, index) in data">
                                    <vs-td> {{ detail.packing_id }} </vs-td>
                                    <vs-td> {{ detail.product_code }} </vs-td>
                                    <vs-td> {{ detail.description_1 }} </vs-td>
                                    <vs-td> {{ detail.pack_id }} </vs-td>
                                    <vs-td> {{ detail.batch }} </vs-td>
                                    <vs-td> {{ detail.expired_date }} </vs-td>
                                    <vs-td> {{ detail.check_qty }} </vs-td>
                                    <vs-td> {{ detail.check_uom }} </vs-td>
                                    <vs-td> {{ detail.check_base_qty }} </vs-td>
                                    <vs-td> {{ detail.base_uom }} </vs-td>
                                    <vs-td> {{ detail.stock_type }} </vs-td>
                                    <vs-td> {{ detail.update_time }} </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                    <vs-tab label="Transport and Unloading">
                        <div class="mt-6 vx-row">
                            <div class="w-full vx-col lg:w-1/4">
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Picker
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.transport_unloading.picker" :disabled="!editMode"/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Checker
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.transport_unloading.checker" :disabled="!editMode"/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Supervisor
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.transport_unloading.supervisor" :disabled="!editMode"/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Start Loading
                                    </div>
                                    <div class="w-2/3 vx-col">
                                    <flat-pickr class="w-full" v-model="data.transport_unloading.start_loading"  :disabled="!editMode"/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        End Loading
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <flat-pickr class="w-full" v-model="data.transport_unloading.end_loading"  :disabled="!editMode"/>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full vx-col lg:w-1/4">
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Payment Type
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.transport_unloading.payment_type_id" :disabled="!editMode"/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Currency
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.transport_unloading.currency_id" :disabled="!editMode"/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Order Value
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.transport_unloading.order_value" :disabled="!editMode"/>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full vx-col lg:w-1/4">
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Vehicle ID
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <div class="vehicle-select-container" v-if="editMode">
                                            <vs-input class="w-full" :value="data.transport_unloading.vehicle_id_label" readonly/>
                                            <div @click="showVehiclePickerModal" class="vehicle-select-overlay"></div>
                                        </div>
                                        <vs-input v-else class="w-full" :value="data.transport_unloading.vehicle_id_label" disabled/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Driver
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.transport_unloading.driver" disabled/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Vehicle Type
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" :value="data.transport_unloading.vehicle_type_id_label" disabled/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Transporter ID
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.transport_unloading.transporter_id" disabled/>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        &nbsp;
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.transport_unloading.transporter_name" disabled/>
                                    </div>
                                </div>
                            </div>
                            <div class="w-full vx-col lg:w-1/4">
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Order Source
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-select
                                            class="selectExample"
                                            v-model="data.transport_unloading.order_source_id"
                                            width="100%"
                                            autocomplete
                                            disabled
                                        >
                                            <vs-select-item v-for="(item, index) in order_source.data" :key="index" :value="item.id" :text="item.name"/>
                                        </vs-select>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Service Type
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-select
                                            class="selectExample"
                                            v-model="data.transport_unloading.service_type_id"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchDropdown($event, service_type)"
                                            disabled
                                        >
                                            <vs-select-item v-for="(item, index) in service_type.data" :key="index" :value="item.id" :text="item.service_type"/>
                                        </vs-select>
                                    </div>
                                </div>
                                <div class="mb-3 vx-row">
                                    <div class="w-1/3 vx-col">
                                        Tracking Reference
                                    </div>
                                    <div class="w-2/3 vx-col">
                                        <vs-input class="w-full" v-model="data.transport_unloading.tracking_reference" disabled/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="External Notes">
                        <vs-textarea height="200" class="mt-5" label="External Notes" :disabled="!editMode" v-model="data.external_note"/>
                    </vs-tab>
                    <vs-tab label="Internal Notes">
                        <vs-textarea height="200" class="mt-5" label="Internal Notes" :disabled="!editMode" v-model="data.internal_note"/>
                    </vs-tab>
                    <vs-tab label="Attachment">
                        <vs-table :data="attachments">
                            <template slot="thead">
                                <vs-th>No.</vs-th>
                                <vs-th>File Name</vs-th>
                                <vs-th>Action</vs-th>
                            </template>
                            <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="indextr">
                                    {{ indextr + 1 }}
                                </vs-td>
                                <vs-td :data="data[indextr].file_name">
                                    {{ data[indextr].file_name }}
                                </vs-td>
                                <vs-td :data="indextr">
                                    <vs-button color="success" class="mb-4 mr-1 btn md:mb-0" @click="removeDetail(index)" :disabled="editMode ? false : true">Download</vs-button>
                                    <vs-button color="danger" class="mb-4 mr-1 btn md:mb-0" @click="removeDetail(index)" :disabled="editMode ? false : true">Remove</vs-button>
                                </vs-td>
                            </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                    <vs-tab label="Operators">
                        <label for="" class="vs-input--label">Operators</label>
                        <vs-select
                            class="selectExample"
                            v-model="operators"
                            width="100%"
                            autocomplete
                            multiple
                            :disabled="!editMode"
                        >
                            <vs-select-item v-for="(item, index) in operatorData" :key="index" :value="item.id" :text="item.name"/>
                        </vs-select>
                    </vs-tab>
                </vs-tabs>
            </vs-card>
        </div>
        <vs-prompt
            @accept="goodIssue"
            :active.sync="activeGoodIssue"
            title="Good Issue"
            color="success"
            >
            <div class="con-exemple-prompt">
                <label for="" class="vs-input--label">Enter Good Issue Date</label>
                <flat-pickr class="w-full" v-model="goodIssueDate"/>

                <vs-alert v-if="goodIssueError" color="danger" vs-icon="new_releases" class="mt-10" >
                    {{ goodIssueError }}
                </vs-alert>
            </div>
        </vs-prompt>
        <vs-popup
            :active.sync="moModal"
            title="Movement Orders"
            fullscreen
        >
            <div class="flex flex-wrap items-center justify-end">
                <div class="flex items-center">
                    <vs-button  @click="confirmData" class="mb-4 mr-1 btn md:mb-0" icon="check">Confirm</vs-button>
                    <vs-button  @click="cancelData" class="mb-4 mr-1 btn md:mb-0" icon="cancel">Cancel</vs-button>
                    <vs-button class="mb-4 mr-1 md:mb-0" icon="filter_list">Filter</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="my-4 ag-theme-material w-100 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="moList"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                :pagination="true"
                rowSelection="multiple"
            >
            </ag-grid-vue>
        </vs-popup>
        <vs-popup
            :active.sync="pickingListPopup"
            title="Movement Orders"
        >
            <div class="flex flex-wrap items-center justify-end">
                <div class="flex items-center">
                    <vs-button @click="printPickList" class="mb-4 mr-1 btn md:mb-0" icon="print">Print</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions2"
                class="my-4 ag-theme-material w-100 ag-grid-table"
                :columnDefs="pickListDefs"
                :defaultColDef="defaultColDef2"
                :rowData="pickList"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
            >
            </ag-grid-vue>
        </vs-popup>

        <vs-popup
            :active.sync="reverseListPopup"
            title="Movement Orders"
        >
            <div class="flex flex-wrap items-center justify-end">
                <div class="flex items-center">
                    <vs-button @click="printReversePickList" class="mb-4 mr-1 btn md:mb-0" icon="print">Print</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions3"
                class="my-4 ag-theme-material w-100 ag-grid-table"
                :columnDefs="reversePickListDefs"
                :defaultColDef="defaultColDef2"
                :rowData="reversePickList"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
            >
            </ag-grid-vue>
        </vs-popup>

        <vs-prompt @accept="printPackingLabel" title="Filter" :active.sync="showPrintLabelPrompt">
        <div class="con-exemple-prompt">
            <vs-input v-model="printLabelQty" class="w-full mb-2" label="Label Qty" />
        </div>
    </vs-prompt>

    <!-- start:modals > vehicle picker modal -->
    <vs-popup
        title="Select Vehicle ID"
        :active.sync="vehicle_modal.state"
    >
        <div class="pb-5 row">
            <div class="flex flex-wrap items-center justify-end mt-5">
                <div class="flex items-center">
                    <vs-button
                        class="mb-4 md:mb-0"
                        icon="add"
                        @click="showAddVehicleModal"
                        color="primary"
                    >Add New</vs-button>
                </div>
            </div>

            <vs-table
                stripe
                max-items="30"
                pagination
                search
                hoverFlat
                :data="vehicle_modal.data"
            >
                <template slot="thead">
                    <vs-th sort-key="id">Vehicle ID</vs-th>
                    <vs-th sort-key="vehicle_code">Vehicle Code</vs-th>
                    <vs-th sort-key="vehicle_type.vehicle_type">Vehicle Type</vs-th>
                    <vs-th sort-key="transport.transporter_code">Transporter ID</vs-th>
                    <vs-th sort-key="driver">Driver</vs-th>
                    <vs-th sort-key="phone">Phone</vs-th>
                    <vs-th sort-key="contract_type.contract_type">Contract Type</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr
                        :data="tr"
                        :key="indextr"
                        v-for="(tr, indextr) in data"
                        @dblclick.native="selectVehicle(tr)"
                    >
                        <vs-td :data="tr.id">
                            {{ tr.id }}
                        </vs-td>
                        <vs-td :data="tr.vehicle_code">
                            {{ tr.vehicle_code }}
                        </vs-td>
                        <vs-td :data="tr.vehicle_type_id">
                            {{ tr.vehicle_type ? tr.vehicle_type : '' }}
                        </vs-td>
                        <vs-td :data="tr.transporter_id">
                            {{ tr.transporter_code }}
                        </vs-td>
                        <vs-td :data="tr.id">
                            {{ tr.driver }}
                        </vs-td>
                        <vs-td :data="tr.id">
                            {{ tr.phone }}
                        </vs-td>
                        <vs-td :data="tr.contract_type_id">
                            {{ tr.contract_type }}
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </vs-popup>
    <!-- end:modals > vehicle picker modal -->

    <!-- start:modals > add vehicle modal -->
    <vs-prompt
        buttons-hidden
        title="Add Vehicle"
        :active.sync="add_vehicle_modal.state"
    >
        <div class="con-exemple-prompt">
            <vs-input
                v-model="add_vehicle_modal.form.vehicle_code"
                class="mb-2 w-full wr_input"
                label="Vehicle Code *"
            />
            <label class="vs-input--label">Transporter *</label>
            <vs-select
                class="selectExample mb-2"
                v-model="add_vehicle_modal.form.transporter_id"
                width="100%"
                autocomplete
                @input-change="searchDropdown($event, add_vehicle_modal.transporter)"
            >
                <vs-select-item v-for="(item, index) in add_vehicle_modal.transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
            </vs-select>
            <label class="vs-input--label">Contract Type *</label>
            <vs-select
                class="selectExample mb-2"
                v-model="add_vehicle_modal.form.contract_type_id"
                width="100%"
                autocomplete
                @input-change="searchDropdown($event, add_vehicle_modal.contract_type)"
            >
                <vs-select-item v-for="(item, index) in add_vehicle_modal.contract_type.data" :key="index" :value="item.id" :text="item.contract_type"/>
            </vs-select>
            <vs-input v-model="add_vehicle_modal.form.driver" class="mb-2 w-full" label="Driver *" />
            <vs-input
                v-model="add_vehicle_modal.form.phone"
                class="mb-2 w-full"
                label="Phone *"
                maxlength="13"
            />
            <label class="vs-input--label">Vehicle Type *</label>
            <vs-select
                class="selectExample mb-2"
                v-model="add_vehicle_modal.form.vehicle_type_id"
                width="100%"
                autocomplete
                @input-change="searchDropdown($event, add_vehicle_modal.vehicle_type)"
            >
                <vs-select-item v-for="(item, index) in add_vehicle_modal.vehicle_type.data" :key="index" :value="item.id" :text="item.vehicle_type"/>
            </vs-select>
            <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
                <vs-button color="primary" @click="addVehicle">Save</vs-button>
            </vs-row>
        </div>
    </vs-prompt>
    <!-- end:modals > add vehicle modal -->

    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { AgGridVue } from "ag-grid-vue"
    import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'

	export default {
		components:{
			vSelect,
            flatPickr,
            AgGridVue
		},
		data(){
			return {
                attachments:[],
                operators: [],
                operatorData: [],
                printLabelQty: 1,
                showPrintLabelPrompt: false,
                selected: [],
                editMode: false,
                isLoading: false,
                detailsCount: 0,
                data: {
                    id: '',
                    outbound_reference: '',
                    order_source: '',
                    do_reference: '',
                    req_del_date: '',
                    client_id: null,
                    origin_id: null,
                    origin_name: '',
                    origin_address_1: '',
                    origin_address_2: '',
                    destination_id: null,
                    destination_name: '',
                    destination_address_1: '',
                    destination_address_2: '',
                    status: '',
                    order_type_id: null,
                    posting_date: null,
                    po_reference: '',
                    po_date: null,
                    details: [],
                    picking: [],
                    packing: [],
                    transport_unloading: {
                        picker: '',
                        checker: '',
                        supervisor: '',
                        start_loading: '',
                        end_loading: '',
                        payment_type_id: null,
                        currency_id: null,
                        order_value: '',
                        vehicle_id: null,
                        vehicle_id_label: '',
                        driver: '',
                        vehicle_type_id: null,
                        vehicle_type_id_label: '',
                        transporter_id: null,
                        transporter_name: '',
                        service_type_id: null,
                        tracking_reference: ''
                    }
                },
                goodIssueError: '',
                activeGoodIssue: false,
                goodIssueDate: new Date(),
                moData: [],
                moModal: false,
                moList: [],
                gridOptions: {},
                gridOptions2: {},
                gridOptions3: {},
                maxPageNumbers: 7,
                gridApi: null,
                gridApi2: null,
                gridApi3: null,
                columnDefs: null,
                pickListDefs: null,
                reversePickListDefs: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                defaultColDef2: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                pickingListPopup: false,
                pickList: [],
                client: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients',
                    objectKey: 'client_code'
                },
                customer: {
                    data: [],
                    loading: false,
                    endpoint: 'master/customers',
                    objectKey: 'name'
                },
                order_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/ordertypes',
                    objectKey: 'order_type'
                },
                transporter: {
                    data: [],
                    loading: false,
                    endpoint: 'master/transporters',
                    objectKey: 'transporter_code'
                },
                service_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/servicetypes',
                    objectKey: 'service_type'
                },
                order_source: {
                    data: [],
                },
                reverseListPopup: false,
                reversePickList: [],
                vehicle_modal: {
                    state: false,
                    data: []
                },
                add_vehicle_modal: {
                    state: false,
                    form: {
                        vehicle_code: '',
                        transporter_id: '',
                        contract_type_id: '',
                        driver: '',
                        phone: '',
                        vehicle_type_id: '',
                        vehicle_type: ''
                    },
                    transporter: {
                        data: [],
                        loading: false,
                        endpoint: 'master/transporters',
                        objectKey: 'transporter_code'
                    },
                    contract_type: {
                        data: [],
                        loading: false,
                        endpoint: 'master/contracttypes',
                        objectKey: 'contract_type'
                    },
                    vehicle_type: {
                        data: [],
                        loading: false,
                        endpoint: 'master/vehicletypes',
                        objectKey: 'vehicle_type'
                    },
                }
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData(api) {
                return this.$http.get(api)
            },
            handleFileUpload(event){
            this.file = event.target.files[0];
            },
            submitForm() {
                let deleted = 0
                let error = false

                this.data.details.map(item => {
                    if(item.status == 'delete') {
                        deleted++
                    }
                })

                if(deleted >= this.data.details.length) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error saving',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: `Detail can't be empty`
                    })
                }
                else {
                    this.data.details.map(detail => {
                        if(detail.base_qty > detail.open_qty_fixed) {
                            this.$vs.notify({
                                color: 'danger',
                                title: 'Error saving',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: `Line ${detail.line_id} - Qty can't be higher than open qty`
                            })
                            error = true
                        }
                    })

                    if(error) {
                        return false
                    }

                    this.isLoading = true
                    const tu = this.data.transport_unloading
                    const doData = {
                        do_id: this.$route.params.id,
                        do_reference: this.data.do_reference,
                        posting_date: this.data.posting_date,
                        external_note: this.data.external_note,
                        internal_note: this.data.internal_note,
                        operators: this.operators,
                        vehicle_id: tu.vehicle_id,
                        driver: tu.driver,
                        vehicle_type_id: tu.vehicle_type_id,
                        transporter_id: tu.transporter_id,
                        transporter_name: tu.transporter_name
                    }

                    const details = this.data.details

                    const dataSend = {
                        do_data: doData,
                    }

                    this.isLoading = true
                    let document_send = {
                module_id:this.$route.params.id,
                module_name:'do'
            };
            let file = new FormData();
            file.append("file_name",this.file);
            this.$http.post('/attachment/uploads',file,{
              headers: {
                  "Content-Type": "multipart/form-data"
              },
              params: document_send
            })
            .then((resp) => {
                // this.$router.replace('/inbound-delivery');
                // this.on_edit = false;
                this.isLoading = false
                this.$vs.notify({
                color: 'success',
                title: 'Update Success',
                text: 'Update Attachment Succesfully'
                });


            })
            .catch((error) =>{
                this.isLoading = false
            });
                    this.$http.put('outbound/deliveryorder/' + this.$route.params.id + '/update', doData)
                    .then(() => {
                        this.$vs.notify({
                            color: 'success',
                            title: 'Updated successfully',
                            iconPack: 'feather',
                            icon:'icon-check',
                            text: 'Delivery order updated'
                        })

                        this.editMode = false
                        this.fetchAllData()
                    })
                    .catch((error) => this.handleError(error))
                    .then(() => {
                        this.isLoading = false
                    })
                }
            },
            back() {
                if(this.editMode) {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved?',
                        acceptText: 'Leave Page',
                        accept: () => this.$router.go(-1),
                    })
                }
                else{
                    this.$router.push({name: 'delivery-order'})
                }
            },
            fetchAllData() {
                this.isLoading = true
                Promise.all([this.fetchData('outbound/deliveryorder/' + this.$route.params.id), this.$http.get('master/operators/all'), this.$http.post('unlock_all')])
                .then(this.$http.spread((deliveryorder, op) => {
                    const res = deliveryorder.data;
                    const tu = res.transport_unloading;
                    this.operatorData = op.data;
                    this.operators = this.$_.map(res.operators, 'id');

                    if(tu.transporter) {
                        this.transporter.data.push({
                            id: tu.transporter.id,
                            transporter_code: tu.transporter.transporter_code
                        });
                    }

                    if(tu.service_type) {
                        this.service_type.data.push({
                            id: tu.service_type.id,
                            service_type: tu.service_type.service_type
                        });
                    }

                    if(tu.order_source) {
                        this.order_source.data.push({
                            id: tu.order_source.id,
                            name: tu.order_source.name
                        });
                    }

                    const data = {
                        id: res.id,
                        outbound_reference: res.outbound_reference,
                        order_source: res.order_source,
                        do_reference: res.do_reference,
                        req_del_date: res.req_del_date,
                        client_id: res.client.id,
                        origin_id: res.origin.id,
                        origin_name: res.origin.name,
                        origin_address_1: res.origin.address_1,
                        origin_address_2: res.origin.address_2,
                        destination_id: res.destination.id,
                        destination_name: res.destination.name,
                        destination_address_1: res.destination.address_1,
                        destination_address_2: res.destination.address_2,
                        status: res.status,
                        order_type_id: res.order_type.id,
                        posting_date: res.posting_date,
                        po_reference: res.po_reference,
                        po_date: res.po_date,
                        details: [],
                        checking: [],
                        internal_note: res.internal_note,
                        external_note: res.external_note,
                        transport_unloading: {
                            picker: tu.picker,
                            checker: tu.checker,
                            supervisor: tu.supervisor,
                            start_loading: tu.start_loading,
                            end_loading: tu.end_loading,
                            payment_type_id: tu.payment_type_id,
                            currency_id: tu.currency_id,
                            order_value: tu.order_value,
                            vehicle_id: tu.vehicle_id || (tu.vehicle ? tu.vehicle.id : null),
                            vehicle_id_label: (tu.vehicle_id || (tu.vehicle ? tu.vehicle.id : null)) ? `${tu.vehicle_id || tu.vehicle.id} (${tu.vehicle ? tu.vehicle.vehicle_code : ''})` : '',
                            driver: tu.driver,
                            vehicle_type_id: tu.vehicle_type_id || (tu.vehilce_type ? tu.vehilce_type.id : (tu.vehicle_type ? tu.vehicle_type.id : null)),
                            vehicle_type_id_label: (function() { var vt = tu.vehilce_type || tu.vehicle_type; var vtId = tu.vehicle_type_id || (vt ? vt.id : null); return vtId ? `${vtId} (${vt ? vt.vehicle_type : ''})` : ''; })(),
                            transporter_id: tu.transporter ? tu.transporter.id : tu.transporter_id,
                            transporter_name: tu.transporter ? tu.transporter.name : '',
                            service_type_id: tu.service_type ? tu.service_type.id : tu.service_type,
                            tracking_reference: tu.tracking_reference,
                            order_source_id: tu.order_source ? tu.order_source.id : null
                        }
                    };

                    data.details = res.details.map(item => {
                        item.product_code = item.product.product_code;
                        item.description_1 = item.product.description_1;
                        item.base_uom = item.product.base_uom;
                        return item;
                    });

                    data.picking = res.picking.map(item => {
                        item.product_code = item.product.product_code;
                        item.description_1 = item.product.description_1;
                        item.base_uom = item.product.base_uom;
                        return item;
                    });

                    data.packing = res.packing.map(item => {
                        item.product_code = item.product.product_code;
                        item.description_1 = item.product.description_1;
                        item.base_uom = item.product.base_uom;
                        return item;
                    });

                    this.data = data;

                    // this.data.details = []
                    // this.data.id = deliveryorder.data.id
                    // this.data.outbound = deliveryorder.data.outbound
                    // this.data.status = deliveryorder.data.status
                    // this.data.external_note = deliveryorder.data.external_note
                    // this.data.internal_note = deliveryorder.data.internal_note
                    // this.data.do_reference = deliveryorder.data.do_reference
                    // this.data.posting_date = deliveryorder.data.posting_date
                    // this.data.transport_unloading = deliveryorder.data.transport_unloading
                    // this.data.transport_unloading.transporter_name = ''


                    this.client.data.push(res.client)
                    this.customer.data.push(res.origin)
                    this.customer.data.push(res.destination)
                    this.order_type.data.push(res.order_type)
                    // this.customer.data.push(deliveryorder.data.outbound.origin)
                    // this.customer.data.push(deliveryorder.data.outbound.destination)
                    // this.order_type.data.push(deliveryorder.data.outbound.order_type)

                    // if(deliveryorder.data.transport_unloading.service_types) {
                    //     this.service_type.data.push(deliveryorder.data.transport_unloading.service_types)
                    // }

                    // if(deliveryorder.data.transport_unloading.transporter) {
                    //     this.transporter.data.push(deliveryorder.data.transport_unloading.transporter)
                    //     deliveryorder.data.transport_unloading.transporter_name = deliveryorder.data.transport_unloading.transporter.name
                    // }

                    // deliveryorder.data.details.map((detail) => {
                    //     detail.uomOptions = []

                    //     detail.uom_list.map(uom => {
                    //         detail.uomOptions.push({
                    //             value: uom.uom.id,
                    //             text: uom.uom.name,
                    //             numerator: uom.numerator,
                    //             denominator: uom.denominator
                    //         })
                    //     })

                    //     detail.defaultUom = [
                    //         {
                    //             value: detail.base_uom.id,
                    //             text: detail.base_uom.name,
                    //         }
                    //     ]

                    //     detail.productOptions = [
                    //         {
                    //             value: detail.product.id,
                    //             text: detail.product.product_code
                    //         }
                    //     ]

                    //     detail.stockTypeOptions = [
                    //         {
                    //             value: detail.stock_type.id,
                    //             text: detail.stock_type.name
                    //         }
                    //     ]

                    //     detail.warehouseOptions = [
                    //         {
                    //             value: detail.warehouse.id,
                    //             text: detail.warehouse.warehouses_code
                    //         }
                    //     ]

                    //     detail.status = "update"
                    //     detail.outbound_line_id = detail.id
                    //     detail.numerator = 0
                    //     detail.denominator = 0
                    //     detail.open_qty_fixed = detail.open_qty + detail.base_qty
                    //     this.data.details.push(detail)
                    // })

                    // this.data.picking = deliveryorder.data.picking.map(detail => {
                    //     return {
                    //         mo_id: detail.moh_id,
                    //         do_line_id: detail.line_id,
                    //         warehouse_id: detail.warehouse.warehouses_code,
                    //         product_id: detail.product.product_code,
                    //         product_description: detail.product.description_1,
                    //         pack_id: detail.pack_id,
                    //         batch: detail.batch,
                    //         expired_date: detail.expired_date,
                    //         base_qty: detail.base_qty,
                    //         base_uom: detail.base_uom.name,
                    //         stock_type: detail.stock_type.name,
                    //         source_location_type: detail.source_location_type.code,
                    //         source_location: detail.source_location ? detail.source_location.location_code : detail.source_location_id,
                    //         source_su: detail.source_storage_unit,
                    //         dest_location_type: detail.dest_location_type.code,
                    //         dest_location: detail.dest_location ? detail.dest_location.location_code : detail.destination_location_id,
                    //         dest_su: detail.destination_storage_unit,
                    //         status: detail.mo_statuses.name,
                    //     }
                    // })

                    // this.data.checking = deliveryorder.data.checking

                    // this.data.details.map(item => {
                    //     this.uomChange(item)
                    // })

                    this.isLoading = false
                }))
                .catch(() => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Server Error',
                        text: 'Try again?',
                        accept: () => {
                            this.fetchAllData()
                        },
                        cancel: () => this.$router.go(-1),
                        acceptText: 'Yes',
                        cancelText: 'No'
                    })
                    return;
                })
            },
            removeDetail(index){
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Confirmation',
                    text: 'Delete this detail?',
                    accept: () => {
                        if(this.data.details[index].status == 'update') {
                            this.data.details[index].status = 'delete'
                        }
                        else {
                            this.data.details.splice(index, 1)
                        }
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                })
            },
            uomChange(detail) {
                detail.uomOptions.map(uom => {
                    if(uom.value == detail.uom_id) {
                        detail.denominator = uom.denominator
                        detail.numerator = uom.numerator
                    }
                })
            },
            convertQty(detail){
                detail.base_qty = (detail.qty / detail.denominator) * detail.numerator
                detail.open_qty = detail.open_qty_fixed - detail.base_qty
            },
            lockModule() {
                return this.$http.post('lock', {
                    module_id: this.data.outbound.id,
                    module_name:'outbound-delivery'
                })
            },
            unlockModule() {
                return this.$http.post('unlock_all')
            },
            editForm() {
                this.editMode = true
                // this.isLoading = true
                // this.maxRetry = this.maxRetry - 1
                // this.$http.post('lock', {
                //     module_id: this.data.outbound.id,
                //     module_name:'outbound-delivery'
                // })
                // .then(() => {
                //     setTimeout(() => {
                        // this.editMode = true
                //         this.isLoading = false
                //     }, 500)
                // })
                // .catch(error => {
                //     if(error.response.status == 500) {
                //         this.isLoading = false
                //         this.$vs.notify({
                //             color: 'danger',
                //             title: 'Error',
                //             iconPack: 'feather',
                //             icon:'icon-x',
                //             text: error.response.data
                //         })
                //     }
                //     else{
                //         if(this.maxRetry < 0){
                //             this.isLoading = false
                //             this.$vs.dialog({
                //                 type: 'confirm',
                //                 color: 'danger',
                //                 title: 'Server Error',
                //                 text: 'Try again?',
                //                 accept: () => {
                //                     this.editForm()
                //                     this.maxRetry = 10
                //                 },
                //                 acceptText: 'Yes',
                //                 cancelText: 'No'
                //             })
                //             return;
                //         }
                //         this.editForm()
                //     }
                // })
            },
            goodIssue() {
                if(!this.goodIssueDate) {
                    this.goodIssueError = 'Good Issue date is required'
                    this.activeGoodIssue = true
                    return false
                }

                this.isLoading = true

                const data = {
                    id: this.$route.params.id,
                    gi_date: this.goodIssueDate
                }

                this.$http.post('outbound/deliveryorder/goodissue', data)
                .then(() => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Good issued succesfully'
                    })

                    this.fetchAllData()
                })
                .catch(error => {
                    if(error.response.data.message) {
                        this.isLoading = false
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: error.response.data.message
                        })
                    }
                    else{
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.goodIssue()
                            },
                            acceptText: 'Yes',
                            cancelText: 'No'
                        })
                    }
                })
            },
            confirmMo() {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'success',
                    title: 'Confirmation',
                    text: 'Confirm movement orders?',
                    accept: () => {
                        this.isLoading = true
                        const data = {
                            transaction_source: this.$route.params.id,
                            transaction_types: ['DO', 'RDO']
                        }

                        this.confirmAll(data)
                        .then(res => {
                            this.$vs.notify({
                                color: "success",
                                title: "Success",
                                iconPack: "feather",
                                icon: "icon-check",
                                text: res.data.message || "Success confirm"
                            });

                            this.fetchAllData()
                        })
                        .catch(error => this.handleError(error))
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                })
            },
            acceptMo() {
                this.isLoading = true
                this.$http.post('putaway/confirmputaway', {'list_putaway': JSON.stringify(this.moData)})
                .then(() => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Success confirm'
                    })

                    this.fetchAllData()
                    this.isLoading = false
                })
                .catch(error => console.log(error))
            },
            pickBackground() {
                this.isLoading = true
                this.createPickPartition()
                .then(res => {
                    this.isLoading = false
                    this.$router.push({ name: 'delivery-order-background', params: {data: res.data, id: this.$route.params.id} })
                })
                .catch(error => this.handleError(error))
            },
            createPickPartition() {
                return this.$http.post('outbound/deliveryorder/createpicklist', {
                    id: this.$route.params.id
                })
            },
            pickForeground() {
                this.isLoading = true
                this.createPickPartition()
                .then(res => {
                    this.isLoading = false
                    this.$router.push({ name: 'delivery-order-foreground', params: {data: res.data, id: this.$route.params.id} })
                })
                .catch(error => this.handleError(error))
            },
            viewMo() {
                this.isLoading = true
                this.$http.post('inventories/movementorder/getmolist', {
                    transaction_source: this.$route.params.id,
                    transaction_types: ['DO', 'DO_REVERSE']
                })
                .then(res => {
                    this.moModal = true
                    this.moList = res.data
                })
                .catch(error => {
                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
                .then(() => this.isLoading = false)
            },
            confirmData() {
                const selectedData = this.gridApi.getSelectedRows()
                if(selectedData.length <= 0) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No data selected'
                    })
                }
                else {
                    this.isLoading = true
                    const dataSend = []
                    selectedData.map(item => {
                        dataSend.push({id: item.id})
                    })

                    this.$http.post('putaway/confirmputaway', {'list_putaway': JSON.stringify(dataSend)})
                    .then(res => {
                        this.isLoading = false
                        this.$vs.notify({
                            color: 'success',
                            title: 'Success',
                            iconPack: 'feather',
                            icon:'icon-check',
                            text: 'Confirmed successfully'
                        })

                        this.data = {
                            outbound: {
                                origin: {
                                    address_1: '',
                                    address_2: ''
                                },
                                destination: {
                                    address_1: '',
                                    address_2: ''
                                },
                            },
                            details: [],
                            status: {
                                name: ''
                            },
                            picked: [],
                            do_reference: '',
                            posting_date: null,
                        }

                        this.fetchAllData()
                    })
                    .catch(error => {
                        const message = error.response.data.message ? error.response.data.message : 'Something went wrong'
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: message
                        })
                    })
                    .then(() => this.isLoading = false)
                }
            },
            cancelData() {
                const selectedData = this.gridApi.getSelectedRows()
                if(selectedData <= 0) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No data selected'
                    })
                }
                else {
                    this.isLoading = true
                    const dataSend = []
                    selectedData.map(item => {
                        dataSend.push({id: item.id})
                    })

                    this.$http.post('putaway/cancelputaway', {'list_putaway': JSON.stringify(dataSend)})
                    .then(res => {
                        this.isLoading = false
                        this.$vs.notify({
                            color: 'success',
                            title: 'Success',
                            iconPack: 'feather',
                            icon:'icon-check',
                            text: 'Cancelled successfully'
                        })

                        this.viewMo()
                        this.data = {
                            outbound: {
                                origin: {
                                    address_1: '',
                                    address_2: ''
                                },
                                destination: {
                                    address_1: '',
                                    address_2: ''
                                },
                            },
                            details: [],
                            status: {
                                name: ''
                            },
                            picked: [],
                            do_reference: '',
                            posting_date: null,
                        }

                        this.fetchAllData()
                    })
                    .catch(error => this.handleError(error))
                }
            },
            checkingAndPacking() {
                this.isLoading = true
                this.$http.post('outbound/deliveryorder/checkpackstatus', { id: this.$route.params.id })
                .then(res => {
                    if(this.data.order_source == '14'){
                        this.$router.push({
                            name: 'checking-packing-ginee',
                            params: {
                                fromDeliveryOrder: true,
                                movement_id: res.data.last_movement_id,
                                do_id: this.$route.params.id,
                                order_source_id: this.data.order_source
                            }
                        })
                    }else{
                        this.$router.push({
                            name: 'checking-packing',
                            params: {
                                fromDeliveryOrder: true,
                                movement_id: res.data.last_movement_id,
                                do_id: this.$route.params.id,
                                order_source_id: this.data.order_source
                            }
                        })
                    }
                })
                .catch(error => this.handleError(error))
            },
            printPickListInit() {
                this.isLoading = true
                this.$http.post('outbound/deliveryorder/get_pick_list', {id: this.$route.params.id})
                .then(res => {
                    this.isLoading = false
                    this.pickList = res.data
                    this.pickingListPopup = true
                })
                .catch(error => this.handleError(error))
            },
            printReversePickListInit() {
                this.isLoading = true
                this.$http.post('outbound/deliveryorder/get_reverse_pick_list', {id: this.$route.params.id})
                .then(res => {
                    this.isLoading = false
                    this.reversePickList = res.data
                    this.reverseListPopup = true
                })
                .catch(error => this.handleError(error))
            },
            printPickList() {
                if(this.gridApi2.getSelectedRows().length < 1) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No data selected.'
                    })

                    return false
                }

                const id = this.gridApi2.getSelectedRows().map(item => {
                    return item.id
                })

                this.isLoading = true

                this.$http.post('outbound/deliveryorder/print_pick_list', {id: id}, { responseType: 'blob' })
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .catch(error => this.handleError(error))
            },
            printReversePickList() {
                if(this.gridApi3.getSelectedRows().length < 1) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'No data selected.'
                    })

                    return false
                }

                const id = this.gridApi3.getSelectedRows().map(item => {
                    return item.id
                })

                this.isLoading = true

                this.$http.post('outbound/deliveryorder/print_reverse_pick_list', {id: id}, { responseType: 'blob' })
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .catch(error => this.handleError(error))
            },
            cancelGoodIssue() {
                const globalThis = this
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Reference ' + this.data.do_reference,
                    text: 'Cancel good issue?',
                    accept: () => {
                        globalThis.isLoading = true
                        globalThis.$http.post('outbound/deliveryorder/cancel_good_issue', {id: globalThis.$route.params.id})
                        .then(res => {
                            globalThis.$vs.notify({
                                color: 'success',
                                title: 'Success',
                                iconPack: 'feather',
                                icon:'icon-check',
                                text: 'Cancel good issue successfully'
                            })
                            this.fetchAllData()
                        })
                        .catch(error => {
                            globalThis.isLoading = false
                            const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
                            globalThis.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: message
                            })
                        })
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                })
            },
            printDoNote() {
                this.isLoading = true
                const id = [this.$route.params.id]
                this.$http.post('outbound/deliveryorder/report/delivery_note', {id: id}, {responseType: 'blob'})
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .then(() => this.isLoading = false)
            },
            printInvoice() {
                this.isLoading = true
                const id = [this.$route.params.id]
                this.$http.get(`outbound/deliveryorder/${id}/print_invoice`, {responseType: 'blob'})
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })

                    window.open(URL.createObjectURL(blob))

                    this.isLoading = false
                })
                .catch(error => this.handleError(error, true))
            },
            printTallySheet() {
                this.isLoading = true
                const id = [this.$route.params.id]
                this.$http.post('outbound/deliveryorder/report/tally_sheet', {id: id}, {responseType: 'blob'})
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .catch(error => {
                    this.isLoading = false
                    var reader = new FileReader()
                        const globalThis = this
                        reader.onload = function() {
                            globalThis.isLoading = false
                            const object = JSON.parse(reader.result)
                            const message = object.message ? object.message : 'Something went wrong.'

                            globalThis.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: message
                            })
                        }
                    reader.readAsText(error.response.data)
                })
            },
            printBast() {
                this.isLoading = true
                const id = this.$route.params.id

                this.$http.post(`/tvd/outbound/deliveryorder/print/${id}`, {}, {
                    responseType: 'blob'
                })
                .then(response => {
                    const blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                    this.isLoading = false
                })
                .catch(error => {
                    this.handleError(error)
                    this.isLoading = false
                })
            },
            reversePick() {
                this.isLoading = true
                this.$http.get('master/locations/filter/available')
                .then(locations => {
                    const locationOption = locations.data.map(item => {
                        return {
                            value: item.id,
                            text: item.location_code
                        }
                    })

                    this.$http.post('outbound/deliveryorder/reversepick', { id: this.$route.params.id })
                    .then(res => {
                        this.isLoading = false
                        this.$router.push({ name: 'delivery-order-background-reverse', params: { id: this.$route.params.id, data: res.data, locations: locationOption, header: this.data } })
                    })
                    .catch(err => this.handleError(err))
                })
                .catch(error => this.handleError(error))
            },
            reverseForeground() {
                this.isLoading = true
                this.$http.get('master/locations/filter/available')
                .then(locations => {
                    const locationOption = locations.data.map(item => {
                        return {
                            value: item.id,
                            text: item.location_code
                        }
                    })

                    this.$http.post('outbound/deliveryorder/reversepick', { id: this.$route.params.id })
                    .then(res => {
                        this.isLoading = false
                        this.$router.push({ name: 'delivery-order-foreground-reverse', params: { id: this.$route.params.id, data: res.data, locations: locationOption, header: this.data } })
                    })
                    .catch(err => this.handleError(err))
                })
                .catch(error => this.handleError(error))
            },
            printPackingList() {
                this.isLoading = true
                this.$http.post('outbound/deliveryorder/check/print_packing_list', {id: this.$route.params.id}, { responseType: 'blob' })
                .then(response => {
                    this.isLoading = false
                    var blob = new Blob([response.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob))
                })
                .catch(error => {
                    var reader = new FileReader()
                    const globalThis = this
                    reader.onload = function() {
                        globalThis.isLoading = false
                        const object = JSON.parse(reader.result)
                        const message = object.message ? object.message : 'Something went wrong'

                        globalThis.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: message
                        })
                    }
                    reader.readAsText(error.response.data)
                })
            },
            showVehiclePickerModal() {
                this.isLoading = true

                this.$http.post('master/vehicle?nopage=y')
                .then(res => {
                    this.vehicle_modal.data = res.data.data

                    setTimeout(() => {
                        this.isLoading = false
                        this.vehicle_modal.state = true
                    }, 500)
                }).catch(() => {
                    this.isLoading = false
                })
            },
            selectVehicle(vehicle) {
                this.data.transport_unloading.vehicle_id = vehicle.id
                this.data.transport_unloading.vehicle_id_label = `${vehicle.id} (${vehicle.vehicle_code || ''})`
                this.data.transport_unloading.driver = vehicle.driver
                this.data.transport_unloading.vehicle_type_id = vehicle.vehicle_type_id
                this.data.transport_unloading.vehicle_type_id_label = `${vehicle.vehicle_type_id} (${vehicle.vehicle_type || ''})`
                this.data.transport_unloading.transporter_id = vehicle.transporter_id
                this.data.transport_unloading.transporter_name = vehicle.transporter_code
                this.vehicle_modal.state = false
            },
            showAddVehicleModal() {
                this.vehicle_modal.state = false
                this.add_vehicle_modal.state = true
                this.add_vehicle_modal.form = {
                    vehicle_code: '',
                    transporter_id: '',
                    contract_type_id: '',
                    driver: '',
                    phone: '',
                    vehicle_type_id: '',
                    vehicle_type: ''
                }
                this.fetchAddVehicleModalDropdown()
            },
            addVehicle() {
                this.isLoading = true

                this.$http.post('master/vehicle/store', this.add_vehicle_modal.form)
                .then(() => {
                    this.isLoading = false
                    this.add_vehicle_modal.state = false

                    this.$vs.notify({
                        color: 'success',
                        title: 'Data Added',
                        iconPack: 'feather',
                        icon: 'icon-check',
                        text: 'The selected data was successfully Added'
                    })
                })
                .catch(error => this.handleError(error))
            },
            fetchAddVehicleModalDropdown() {
                this.isLoading = true

                return Promise.all([
                    this.$http.post('master/transporters'),
                    this.$http.post('master/contracttypes'),
                    this.$http.post('master/vehicletypes'),
                ]).then(
                    this.$http.spread((transporters, contracttypes, vehicletypes) => {
                        transporters.data.data.map(transporter => {
                            if(this.add_vehicle_modal.transporter.data.findIndex(a => a.id == transporter.id) === -1) {
                                this.add_vehicle_modal.transporter.data.push(transporter)
                            }
                        })

                        contracttypes.data.data.map(contract_type => {
                            if(this.add_vehicle_modal.contract_type.data.findIndex(a => a.id == contract_type.id) === -1) {
                                this.add_vehicle_modal.contract_type.data.push(contract_type)
                            }
                        })

                        vehicletypes.data.data.map(vehicle_type => {
                            if(this.add_vehicle_modal.vehicle_type.data.findIndex(a => a.id == vehicle_type.id) === -1) {
                                this.add_vehicle_modal.vehicle_type.data.push(vehicle_type)
                            }
                        })

                        this.isLoading = false
                    })
                )
            },
            printPackingLabel() {
                this.isLoading = true
                if(this.data.order_source == 14){
                    this.$http.post('outbound/deliveryorder/check/print_packing_label', {id: this.$route.params.id, qty: this.printLabelQty}, { responseType: 'json' })
                    .then(response => {
                        this.isLoading = false
                        window.open(response.data.url)
                    })
                    .catch(error => {
                        this.isLoading = false
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: `Print failed, please check order in GINEE`
                        })
                    })
                }else{
                    this.$http.post('outbound/deliveryorder/check/print_packing_label', {id: this.$route.params.id, qty: this.printLabelQty}, { responseType: 'blob' })
                    .then(response => {
                        this.isLoading = false
                        var blob = new Blob([response.data], {
                            type: 'application/pdf'
                        })
                        window.open(URL.createObjectURL(blob))
                    })
                    .catch(error => {
                        var reader = new FileReader()
                        const globalThis = this
                        reader.onload = function() {
                            globalThis.isLoading = false
                            const object = JSON.parse(reader.result)
                            const message = object.message ? object.message : 'Something went wrong'

                            globalThis.$vs.notify({
                                color: 'danger',
                                title: 'Error',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: message
                            })
                        }
                        reader.readAsText(error.response.data)
                    })
                }
            },
        },
        mounted(){
            if(!this.$route.params.id) {
                this.$router.push({ name: 'delivery-order'})
            }
            else {
                this.fetchAllData()
                this.$http.get('attachment/'+this.$route.params.id).then((res) => {
            this.attachments = res.data.result
            });
            }

            this.gridApi = this.gridOptions.api
            this.gridApi2 = this.gridOptions2.api
            this.gridApi3 = this.gridOptions3.api
        },
        beforeMount() {
            this.pickListDefs = [
                {
                    headerName: 'ID',
                    field: 'id',
                    width: 250,
                },
                {
                    headerName: 'Movement Date',
                    field: 'movement_date',
                    width: 250,
                },
            ]

            this.reversePickListDefs = [
                {
                    headerName: 'ID',
                    field: 'id',
                    width: 250,
                },
                {
                    headerName: 'Movement Date',
                    field: 'movement_date',
                    width: 250,
                },
            ]

            this.columnDefs = [
                {
                    headerName: 'ID',
                    field: 'id',
                    width: 250,
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                },
                {
                    headerName: 'Movement Date',
                    field: 'movement_date',
                    width: 150,
                },
                {
                    headerName: 'Transaction Source',
                    field: 'transaction_source',
                    width: 200,
                },
                {
                    headerName: 'Reference',
                    field: 'gr_reference',
                    width: 100,
                    // pinned: 'left'
                },
                {
                    headerName: 'Client ID',
                    width: 100,
                    field: 'client.client_code'
                },
                {
                    headerName: 'Warehouse ID',
                    field: 'warehouse.name',
                    width: 100,
                },
                {
                    headerName: 'Product ID',
                    field: 'product.product_code',
                    width: 100,
                },
                {
                    headerName: 'Description',
                    field: 'product.description_1',
                    width: 150,
                },
                {
                    headerName: 'Pack ID',
                    field: 'pack_id',
                    width: 150,
                },
                {
                    headerName: 'Batch',
                    field: 'batch',
                    width: 150,
                },
                {
                    headerName: 'Exp. Date',
                    field: 'expired_date',
                    width: 150,
                },
                {
                    headerName: 'Base Qty',
                    field: 'base_qty',
                    width: 100,
                },
                {
                    headerName: 'Base UoM',
                    field: 'base_uom.name',
                    width: 100,
                },
                {
                    headerName: 'Stock Type',
                    field: 'stock_type.name',
                    width: 100,
                },
                {
                    headerName: 'Src. Location Type',
                    field: 'source_location_type.code',
                    width: 100,
                },
                {
                    headerName: 'Src. Location ID',
                    field: 'source_location_id',
                    width: 100,
                },
                {
                    headerName: 'Src. Storage Unit',
                    field: 'source_storage_unit',
                    width: 150,
                },
                {
                    headerName: 'Dest. Location Type',
                    field: 'dest_location_type.code',
                    width: 150,
                },
                {
                    headerName: 'Dest. Location ID',
                    field: 'dest_location_id.location_code',
                    width: 150,
                },
                {
                    headerName: 'Dest. Storage Unit',
                    field: 'destination_storage_unit',
                    width: 150,
                },
                {
                    headerName: 'Status',
                    field: 'mo_statuses.name',
                    width: 200,
                },
            ];
        }
	}
</script>
